import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

const RegistrationSuccess = ({ type = "user" }) => {
  useEffect(() => {
    localStorage.clear();
  }, []);

  const getContent = () => {
    switch (type) {
      case "group":
        return {
          heading: "We look forward to welcoming your practice to the network.",
          lines: [
            "Thank you for completing your registration. We’ll review your information and follow up within one business day.",
            "Once approved, you’ll receive an email to verify your account so you can log in and begin exploring the network.",
          ],
        };

      case "treatment":
        return {
          heading: "We look forward to learning more about your program.",
          lines: [
            "Thank you for completing your registration. Our team will review your information and reach out within one business day to discuss your program and next steps.",
          ],
        };

      default:
        return {
          heading: "We look forward to welcoming you to the network.",
          lines: [
            "Thank you for completing your registration. Our team will review and verify your license information within one business day.",
            "Once approved, you’ll receive an email to verify your account so you can log in and begin exploring the network.",
          ],
        };
    }
  };

  const { heading, lines } = getContent();

  return (
    <Container className="hideShadow" sx={{ minHeight: "75vh" }}>
      <div className="formStyle">
        <Typography
          variant="h4"
          sx={{ marginBottom: "20px" }}
        >
          {heading}
        </Typography>

        {lines.map((line, index) => (
          <Typography
            key={index}
            variant="body1"
            sx={{ marginBottom: "16px" }}
          >
            {line}
          </Typography>
        ))}

        <Typography variant="body1">
          Questions? Contact us at{" "}
          <a href="mailto:team@thettn.com">team@thettn.com</a>.
          <br />
          <br />
          Warm regards,
          <br />
          The TTN Team
        </Typography>
      </div>
    </Container>
  );
};

export default RegistrationSuccess;